import type { DossierFile } from '../../services/files/filesService';
import type { DocumentTreeNode } from '../documentTree';
import {
  shouldOpenVirtualEmail,
  VIRTUAL_EMAIL_ID,
} from './virtualEmailFolder';

/** Nœud virtuel « Tous les documents » — jamais un uuid de `dossier_folders`. */
export const ALL_DOCUMENTS_ID = '__all__';

export type DocumentNavId = typeof ALL_DOCUMENTS_ID | typeof VIRTUAL_EMAIL_ID | string;

export function isAllDocumentsNav(id: string): boolean {
  return id === ALL_DOCUMENTS_ID;
}

export function isEmailNav(id: string): boolean {
  return id === VIRTUAL_EMAIL_ID;
}

export function isFolderNav(id: string): boolean {
  return !isAllDocumentsNav(id) && !isEmailNav(id);
}

export function filesForNavSelection(selected: string, files: DossierFile[]): DossierFile[] {
  if (isEmailNav(selected)) return [];
  if (isAllDocumentsNav(selected)) return files;
  return files.filter((f) => f.folder_id === selected);
}

export function uploadFolderId(selected: string): string | null {
  return isFolderNav(selected) ? selected : null;
}

export function navIdFromSearch(search: string): string {
  return shouldOpenVirtualEmail(search) ? VIRTUAL_EMAIL_ID : ALL_DOCUMENTS_ID;
}

export function findFolderNode(
  nodes: DocumentTreeNode[],
  folderId: string,
): DocumentTreeNode | null {
  for (const node of nodes) {
    if (node.folder.id === folderId) return node;
    const nested = findFolderNode(node.children, folderId);
    if (nested) return nested;
  }
  return null;
}

export function ancestorFolderIds(nodes: DocumentTreeNode[], folderId: string): string[] {
  function walk(list: DocumentTreeNode[], trail: string[]): string[] | null {
    for (const node of list) {
      if (node.folder.id === folderId) return trail;
      const found = walk(node.children, [...trail, node.folder.id]);
      if (found) return found;
    }
    return null;
  }
  return walk(nodes, []) ?? [];
}
